/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosError } from 'axios';
import { Api } from '../../api/axiosApi';

export interface IDetalhesEmpresabyid {
  idempresa: string;
  nome: string;
  cnpj: string;
  fantasia: string;
  endereco: string;
  numero: string;
  bairro: string;
  idmunicipio: string;
  uf: string;
  cep: string;
  telefone: string;
  cnae: number;
  crt: number;
  ie: string;
  csc: string;
  cscid: string;
  certificado: string;
  logo: string;
  serie55: number;
  serie65: number;
  tpamb: number;
  senha: string;
  decimais: number;
  est: boolean;
  refs: boolean;
  tipoimp: number;
  emailcontador: string;
  comissao: boolean;
  enviaremailcontador: boolean;
}
export interface IUpdateImg {
  urlimge: string;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const getById = async (): Promise<IDetalhesEmpresabyid | Error> => {
  try {
    const { data } = await Api.get(`/empresa`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (
  id: string,
  dados: IDetalhesEmpresabyid
): Promise<void | Error> => {
  try {
    await Api.put(`/empresa/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    }
    return new Error('Erro inesperado');
  }
};


const updateByIdImg = async (id: string, image: File | undefined, urlimge: string | null): Promise<void | Error> => {
  try {
    const dados = { urllogo: urlimge };
    const formData = new FormData();
    Object.keys(dados).forEach((key) => {
      formData.append(key, (dados as any)[key]);
    });
    formData.append('file', image || '');

    await Api.put(`/empresalogo/${id}`, formData);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updateByIdCert = async (id: string, cert: File | undefined, urlcrt: string | null): Promise<void | Error> => {
  try {
    const dados = { urlcrt: urlcrt };
    const formData = new FormData();
    Object.keys(dados).forEach((key) => {
      formData.append(key, (dados as any)[key]);
    });
    formData.append('file', cert || '');
    await Api.put(`/empresacert/${id}`, formData);

  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const baixarZipNfe = async (anoMes: string, tipo: string): Promise<Blob | Error> => {
  try {
    const { data } = await Api.get(`/zipnfe/${anoMes}/${tipo}`, {
      responseType: 'blob',
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const blob = error.response.data as Blob;
      try {
        const text = await blob.text();
        const json = JSON.parse(text);
        const errorMessage =
          typeof json?.errors === 'string'
            ? json.errors
            : json?.errors?.default || 'Erro desconhecido na resposta';
        return new Error(errorMessage);
      } catch (parseError) {
        try {
          const fallback = await (error.response.data as Blob).text();
          return new Error(fallback || 'Erro desconhecido ao interpretar erro');
        } catch {
          return new Error('Erro desconhecido ao ler blob');
        }
      }
    }
    if (axios.isAxiosError(error) && error.request) {
      return new Error('Nenhuma resposta do servidor');
    }
    if (axios.isAxiosError(error)) {
      return new Error(error.message);
    }
    return new Error('Erro inesperado');
  }
};

const enviarEmailContador = async (anoMes: string): Promise<void | Error> => {
  try {
    await Api.get(`/enviaremailcontador/${anoMes}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const EmpresaService = {
  getById,
  updateById,
  updateByIdCert,
  updateByIdImg,
  baixarZipNfe,
  enviarEmailContador,
};